import React from 'react' 
import { Types } from "../../@types"
import { useAppCtx, appStore } from "lib/state"
import { immutables, randoms, inspect } from "lib/utils"
import { useConditionalCtx } from "lib/units/dispute/statements/conditionals"

const { __insert, __update } = immutables
const { getUniqueObjByKey } = inspect

export default function useConditional(){

  const { appState, appTools }:any = useAppCtx()
  const { store, AppStore }:any = appStore() 

  const { update }:any = AppStore
  const { usage, currentConditional, updateConditional }:any = useConditionalCtx()

  /** ===== conditional groups and items ================================ */

  const getConditionalById = (refid:string) => currentConditional.items.find( (item:any) => item.refid === refid )
  const getConditionalsInZone = (zone:string) => currentConditional.items.filter( (item:any) => item.zone === zone )
  const getConditionalsInGroup = (group:string) => currentConditional.items.filter( (item:any) => item.group === group )

  const findConditional = () => {

  }


  const saveConditionalObj = () => {
    console.log(currentConditional)
    update("metas.conditionalModal", "save-conditional")
  }

  function loadStatementIntoZone({ zone, data }:{ zone:any; data:any }){
    console.log("loading statement into zone", data)
    
    if( !data.api_value_id && data.apiValueObj ){
      data = { ...data, api_value_id: data.apiValueObj._id }
    }

    let autoResult = null
    if( data.automatic !== undefined ){
      autoResult = data.automatic
    }

    const newGroupObj = { groupref: data.refid, items: [data.refid] }
    const newZoneObj = { zoneref: randoms.string(8, "a1"), groups: [newGroupObj] }
    
    let dz
    if( autoResult !== null ){
      dz = [newZoneObj]
    } else {
      dz = (zone.zoneref === '000') 
      ? [...currentConditional.zones, newZoneObj] 
      : currentConditional.zones.map( (z:any) => {
        if( z.zoneref !== zone.zoneref || z.groups.find( (g:any) => g.groupref === data.refid ) ) return z
        return __insert("groups", newGroupObj, z)
      })
    }

    const newConditional ={
      ...currentConditional,
      items: [...currentConditional.items, {...data, location: "dropzone"}],
      // TODO: CLIPBOARD
      clipboard: currentConditional.clipboard.filter( (item:any) => item.refid !== data.refid ), 
      zones: dz
    }
    updateConditional(newConditional)
  }


  /** ===== groups and zones ============================================= */
  const getZone = (zoneref:string) => currentConditional.zones.find( (zone:any) => zone.zoneref === zoneref )
  const getZoneGroup = (zoneref:string, groupref:string) => getZone(zoneref).groups.find( (group:any) => group.groupref === groupref )
  const zoneHasGroup = (zoneref:string, groupref:string) => getZone(zoneref).groups.includes(groupref)
  // const addToZone = (zoneref:string, itemref:string) => !zoneHasGroup(zoneref, itemref, cs) ?


  function addToZone(zoneref:string, itemref:string){
    const zone:any = getZone(zoneref)
    let newZone:any[]
    if( zoneHasGroup(zoneref, itemref) ) {
      return {...currentConditional} 
    } else {
      const newgroups = [ ...getZone(zoneref).groups, { groupref: itemref, items: [itemref] } ]
      newZone = { ...zone, groups: newgroups }
    }

    const updatedConditional = {...currentConditional, zones: [...currentConditional.zones.push(newZone)] }
    update("currentConditional", updatedConditional)
  }

  function getAllZoneItemObjs(){
    let items:any[] = []
    currentConditional.zones.forEach( (zone:any) => {
      zone.groups.forEach( (group:any) => {
        group.items.forEach( (item:any) => {
          const fullItem = currentConditional.items.find( (itemObj:any) => itemObj.refid === item )
          items.push(fullItem)
        })
      })
    })
    return items
  }


  /* ===== clipboard ===================================================== */
  function addToClipboard(apiValueObj:any){
    const newObj = {
      source: "api",
      refid: randoms.string(8, "a1"),
      api_value_id: apiValueObj._id,
      operator: "",
      value: "",
      tag: "",
      alias: "",
      apiValueObj
    }
    const newClipboard = [...currentConditional.clipboard, newObj]
    updateConditional({ ...currentConditional, clipboard: newClipboard })
    // update("actives.statement.conditional.clipboard", [...currentConditional.clipboard, newObj])
  }


  /* ===== spotlight ===================================================== */
  const closeSpotlight = () => update("metas.conditionalSpotlight", null)

  const putItemInSpotlight = (obj:any) => {
    console.log("here")
    let spotlightObj
    if( obj.source === "automatic" ){
      spotlightObj = {...obj, refid: randoms.string(12, "a#")}
    } else if( obj.source === "tag" ){
      spotlightObj = {...obj, refid: randoms.string(12, "a#")}
    } else {
      const found = (obj.location === 'dropzone') ? obj : currentConditional.clipboard.find( (item:any) => item.refid === obj.item.refid )
      spotlightObj = { 
        ...found.item,
        refid: obj.refid,
        apiValueObj: found.apiValueObj,
        source: found.source,
        conversion: found.conversion,
        location: obj.location,
        operator: found.operator,
        alias: found.alias,
        tag: found.tag,
        value: found.value
      }
    }
    update("metas.conditionalSpotlight", spotlightObj)
  }
  
  function updateFromSpotlight(data:any){
    if( store.metas.conditionalSpotlight.location === 'clipboard' ){
      const clipboard = currentConditional.clipboard.map( (item:any) => {
        return ( item.refid === data.refid ) ? data : item
      })
      updateConditional({ ...currentConditional, clipboard: clipboard })
      // update("actives.statement.conditional.clipboard", clipboard)
    } else if( store.metas.conditionalSpotlight.location === 'zone' ){
      const newitems = currentConditional.items.map( (item:any) => {
        return ( item.refid !== store.metas.conditionalSpotlight.refid ) ? item : { ...item, ...data }
      })
      updateConditional({ ...currentConditional, items: newitems })
      // update("actives.statement.conditional.items", newitems)
    }
  }

  function cleanupZones(newzones:any[]){
    const cleanzones = newzones.filter( (zone:any, idx:number) => idx === 0 || zone.groups.length > 0 )
    return cleanzones
    // update("actives.statement.conditional.zones", cleanzones)
  }

  function startCleanup(newzones:any[]){
    const cleanzones = newzones.map( (zone:any) => {
      const newgroups = zone.groups.filter( (group:any) => group.items.length > 0 )
      return { ...zone, groups: newgroups }
    })
    console.log(cleanzones)
    return cleanupZones(cleanzones)
    // update("actives.statement.conditional.zones", newzones)
  }

  function removeDropzoneItem(callbackFn?:any){
    const itemToRemove = store.metas.conditionalSpotlight.refid
    console.log(itemToRemove)
    console.log(currentConditional.items)

    // All we are doing here is removing the targeted item from its group
    const newzones = currentConditional.zones.map( (zone:any) => {
      const newgroups = zone.groups.map( (group:any) => {
        console.log(group)
        if( group.items.includes(itemToRemove) ){
          console.log(group)
          const newitems = group.items.filter( (item:any) => item !== itemToRemove )
          return { ...group, items: newitems }
        } else {
          return group
        }
      })
      const result = { ...zone, groups: newgroups }
      console.log(result)
      return result
    })

    const newitems = currentConditional.items.filter( (item:any) => item.refid !== itemToRemove )
    const cleanzones = startCleanup(newzones)
    
    updateConditional({ ...currentConditional, items: newitems, zones: cleanzones })
    // update("actives.statement.conditional", { ...currentConditional, items: newitems, zones: cleanzones })

    if(callbackFn) {
      callbackFn()
    }
  }


  /* ===== drag and drop ================================================= */

  const handleConditionalElementDrag = (e:any, data:any) => {
    console.log(data)
    e.dataTransfer.setData("text/plain", JSON.stringify(data))
  }


  /* ===== modal ========================================================= */
  const openModal = (type:string = "apidata") => update("metas.conditionalModal", type)
  const closeModal = () => update("metas.conditionalModal", null)     


  /* === docs ============================================================ */
  const showdocs = () => update("metas.docsvisible", true)
  const hidedocs = () => update("metas.docsvisible", false)


  /**
   * In order to populate each conditional object, we need to populate it with
   * the associated apiData object. This function will take an array of conditionals
   * 
   * TODO: This function should be moved to the apidata hook
  */
  async function apiValueLookup(arrOfIds:string[]){
    const queryStr = (arrOfIds?.length) ? "?_id=" + arrOfIds.join(",") : ""
    try {
      const response = await fetch(`/api/apidata${queryStr}`)
      const data = await response.json()
      return (data.status === 'success') ? data.payload : []
    } catch(err:any){
      console.log(err)
      throw new Error(err)
    }
  }


  function mergeConditionals({ zoneref, oldgroups, items }:{ zoneref:string; oldgroups:string[]; items:string[] }){
    console.log(items)
    const newGroup = {
      groupref: randoms.string(8, "a1"),
      items: items
    }

    const newzones = currentConditional.zones.map( (zone:any) => {
      if( zone.zoneref !== zoneref ) return zone
      return {
        ...zone,
        groups: [...zone.groups.filter( (group:any) => !oldgroups.includes(group.groupref) ), newGroup]
      }
    })

    console.log(newzones)
    updateConditional({ ...currentConditional, zones: newzones })
    // update("actives.statement.conditional.zones", newzones)
  }


  /**
   * When conditionalState.selected is updated, we need to re-populate zones,, groups, and other areas
   */
  function populateDropzone(){
    // setConditionalState((prev:any) => ({...prev, zones: prev.zones}))
  }


  async function selectConditional(){
    const apiValueObjs = await apiValueLookup( currentConditional.items.map( (item:any) => item.api_value_id ) )
    const items = currentConditional.items.map( (item:any) => ({...item, apiValueObj: apiValueObjs.find( (obj:any) => obj._id === item.api_value_id ) }) )

    // any items which are not assigned to a zone go into the clipboard
    const itemsInZones:any[] = []
    currentConditional.zones.forEach( (zone:any) => {
      zone.groups.forEach( (group:any) => {
        itemsInZones.push(...group.items)
      })
    })

    const unZonedItems = items.filter( (item:any) => !itemsInZones.includes(item.refid) )
    const selectedObj = { ...currentConditional, items: items }

    update("actives.statement.conditional", {...selectedObj, clipboard: unZonedItems, docsvisible: false })
    
  }


  
  return {
    apiValueLookup,
    
    closeSpotlight,
    putItemInSpotlight,
    updateFromSpotlight,

    openModal,
    closeModal,

    mergeConditionals,
    selectConditional,
    saveConditionalObj,

    loadStatementIntoZone,

    populateDropzone,
    getAllZoneItemObjs,
    removeDropzoneItem,
    
    // getZones,
    // getZone,
    // getZoneGroup,
    // zoneHasGroup,
    // addToZone,

    addToClipboard,
    handleConditionalElementDrag,

    showdocs,
    hidedocs,

    // parseTestResults,
    // runTest
    
  }
  
}